export const PIXEL_VERSION = '1.1.0';
